export default {
  name: "schedule-details-modal",
  props:['moreTableData','name'],
  data(){
    return{
      moreScheduleModal:false,
      moreTitleData : [
        {title: 'Week', key:'week', minWidth: 100},
        {title: 'Time', slot:'time', minWidth: 700},
      ],
    }
  },
  methods:{
    // 查看更多
    expandMore: function (e) {
      if (e.target.className.indexOf('ivu-icon-ios-arrow-down') !== -1) {
        $(e.target).parent().parent().addClass('more-expand-schedules');
        $(e.target).parent().parent().removeClass('expand-schedules');
        $(e.target).removeClass('ivu-icon-ios-arrow-down');
        $(e.target).addClass('ivu-icon-ios-arrow-up');
      } else {
        $(e.target).removeClass('ivu-icon-ios-arrow-up');
        $(e.target).addClass('ivu-icon-ios-arrow-down');
        $(e.target).parent().parent().removeClass('more-expand-schedules');
        $(e.target).parent().parent().addClass('expand-schedules');
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/admin/components/commonComponents/scheduleDetailsModal.js